import { Col, Layout } from 'antd';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Redirect, Route, Switch, useLocation } from 'react-router-dom';
import Login from '~/components/screens/Authentication/Login/Login';
import PasswordResetRequest from '~/components/screens/Authentication/PasswordResetRequest/PasswordResetRequest';
import ResetPassword from '~/components/screens/Authentication/ResetPassword/ResetPassword';
import LayoutRow from '~/components/shared/LayoutRow/LayoutRow';
import { RoutingUrl } from '~/helpers/general';
import { SET_REDIRECT_URL } from '~/store/reducers/session';

import './LoginNavigator.scss';

const { Content } = Layout;

function Redirections() {
  const dispatch = useDispatch();
  const location = useLocation();
  const currentPath = location.pathname + location.search;

  useEffect(() => {
    if (currentPath && currentPath !== RoutingUrl.login() && currentPath !== '/') {
      dispatch({ type: SET_REDIRECT_URL, payload: currentPath });
    }
  }, [currentPath, dispatch]);

  return (
    <>
      <Route path='*'>
        <Redirect to={RoutingUrl.login()} />
      </Route>
    </>
  );
}

export default function LoginNavigator() {
  return (
    <>
      <Layout className='layout-login-navigator-block'>
        <Content className='content-login-wrapper'>
          <LayoutRow align='middle'>
            <Col xs={24} md={{ span: 18, offset: 3 }} xl={{ span: 12, offset: 6 }}>
              <div className='panel panel-login'>
                <Switch>
                  <Route path={RoutingUrl.login()} component={Login} />
                  <Route path={RoutingUrl.passwordResetRequest()} component={PasswordResetRequest} />
                  <Route path={RoutingUrl.passwordReset([':token1', ':token2'])} component={ResetPassword} />
                  <Redirections />
                </Switch>
              </div>
            </Col>
          </LayoutRow>
        </Content>
      </Layout>
    </>
  );
}
